(function () {
  document.querySelectorAll(".hw-coupon").forEach(function (coupon) {
    var button = coupon.querySelector(".hw-copy");
    var code = coupon.querySelector(".hw-code");
    var status = coupon.querySelector(".hw-copy-status");
    var hideTimer;

    if (!button || !code || !status || button.dataset.copyReady) return;
    button.dataset.copyReady = "true";

    button.addEventListener("click", async function () {
      if (button.disabled) return;

      button.disabled = true;
      clearTimeout(hideTimer);
      status.textContent = "";

      try {
        await navigator.clipboard.writeText(code.textContent.trim());

        status.textContent = "クーポンコードをコピーしました！";

        hideTimer = setTimeout(function () {
          status.textContent = "";
        }, 2000);
      } catch (error) {
        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(code);
        selection.removeAllRanges();
        selection.addRange(range);

        status.textContent =
          "コピーできませんでした。コードを長押し、または選択してコピーしてください。";
      } finally {
        button.disabled = false;
      }
    });
  });
})();